import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, TransitionGroup as _TransitionGroup, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useRetroStore } from '@/pinia_stores/retro';
import transitions from '@/helpers/transitions';
import ParticipantListItem from '@/components/users/ParticipantListItem.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserList',
    props: {
        participants: { default: () => [] }
    },
    setup(__props) {
        const props = __props;
        const retroStore = useRetroStore();
        const { isModerator } = storeToRefs(retroStore);
        const sortedParticipants = computed(() => {
            return [...props.participants].sort((participant1, participant2) => {
                if (participant1.moderator && !participant2.moderator) {
                    return -1;
                }
                if (!participant1.moderator && participant2.moderator) {
                    return 1;
                }
                const insertedAtSortingValue = new Date(participant1.insertedAt).getTime() - new Date(participant2.insertedAt).getTime();
                if (insertedAtSortingValue) {
                    return insertedAtSortingValue;
                }
                // Both have the same role and were added at the same time, so email sets the order
                return participant1.email.localeCompare(participant2.email);
            });
        });
        const { fadeIn, fadeOut } = transitions.fade;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_TransitionGroup, {
                tag: "ul",
                css: false,
                class: _normalizeClass(["space-y-6", { 'mb-4': !_unref(isModerator) }]),
                "data-cy": "users-list",
                onEnter: _unref(fadeIn),
                onLeave: _unref(fadeOut)
            }, {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedParticipants), (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: item.id
                        }, [
                            _createVNode(ParticipantListItem, { participant: item }, null, 8, ["participant"])
                        ]));
                    }), 128))
                ], undefined, true),
                _: 1
            }, 8, ["class", "onEnter", "onLeave"]));
        };
    }
});
